import { type FC, memo } from 'react';

import { AccommodationOverview } from '@vakantiesnl/components/src/organisms/AccommodationOverview';
import { getAccommodationServerSideProps } from '@vakantiesnl/components/src/pages/accommodation/getAccommodationServerSideProps';
import { withGlobalStateGSSP } from '@vakantiesnl/components/src/utils/globalState/withGlobalState';
import { AvailabilityCheckContextProvider } from '@vakantiesnl/services/src/context/useAvailabilityCheckContext';
import { TripFilterProvider } from '@vakantiesnl/services/src/context/useTripFilterContext';
import { useGetAccommodationByEntityId } from '@vakantiesnl/services/src/hooks/queries';

import microCopies from '@MicroCopiesNL';

import { type GlobalPageProps, type VaknlNextPage } from './_app';
import DefaultLayout from '../layout';

type Props = GlobalPageProps & {
	offer?: string;
	googleAnalyticsCookie?: string;
};

const RenderLayout: FC<Props> = (props) => {
	const { accommodation } = useGetAccommodationByEntityId();

	return (
		<TripFilterProvider key={accommodation.heliosId}>
			<AvailabilityCheckContextProvider>
				<AccommodationOverview
					offer={props.offer}
					accommodation={accommodation}
					googleAnalyticsCookie={props.googleAnalyticsCookie || undefined}
				/>
			</AvailabilityCheckContextProvider>
		</TripFilterProvider>
	);
};

const MemoRenderLayout = memo(RenderLayout);

const AccommodationPage: VaknlNextPage<Props> = (props) => {
	return <MemoRenderLayout {...props} />;
};

export const getServerSideProps = withGlobalStateGSSP((globalState) =>
	getAccommodationServerSideProps(globalState, microCopies),
);

AccommodationPage.Layout = DefaultLayout;

export default AccommodationPage;
